import {
  WAVE_WORKFLOW_STATUSES,
  type WaveRecord,
  type WaveStatus,
} from "@vida/wave-core";

type Props = {
  waves: WaveRecord[];
  onSelect: (wave: WaveRecord) => void;
  onMove: (wave: WaveRecord, status: WaveStatus) => void;
};

export function WaveBoardView({ waves, onSelect, onMove }: Props) {
  return (
    <div className="wave-board">
      {WAVE_WORKFLOW_STATUSES.map((status) => (
        <section key={status} className="board-column">
          <h3>{status}</h3>
          {waves
            .filter((w) => w.status === status)
            .map((wave) => (
              <div
                key={wave.waveId}
                className="board-card"
                draggable
                onDragStart={(e) => {
                  e.dataTransfer.setData("waveId", wave.waveId);
                }}
                onDragOver={(e) => e.preventDefault()}
                onDrop={(e) => {
                  e.preventDefault();
                  const id = e.dataTransfer.getData("waveId");
                  const w = waves.find((x) => x.waveId === id);
                  if (w && w.status !== status) onMove(w, status);
                }}
              >
                <button type="button" onClick={() => onSelect(wave)}>
                  <strong>{wave.title}</strong>
                  <span>{wave.templateId ?? "wave"}</span>
                </button>
                <select
                  value={wave.status}
                  onChange={(e) =>
                    onMove(wave, e.target.value as WaveStatus)
                  }
                >
                  {WAVE_WORKFLOW_STATUSES.map((s) => (
                    <option key={s} value={s}>
                      → {s}
                    </option>
                  ))}
                </select>
              </div>
            ))}
        </section>
      ))}
    </div>
  );
}
